<template>
  <div class="col-sm-4 mb-1" style="min-height: 110px">
    <div :class="`stat-card bg-${isSuccess ? 'success' : 'info'}`">
      <slot name="title"></slot>

      <div class="font-weight-bold">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StatsMarginRateCard",
  props: {
    isSuccess: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="css" scoped>
.stat-card {
  padding: 1rem;
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100%;
}
</style>
